'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sha256 = sha256;
exports.keccak = keccak;
exports.toEthereumAddress = toEthereumAddress;

var _jsSha = require('js-sha256');

var _jsSha2 = require('js-sha3');

var _buffer = require('buffer');

function sha256(payload) {
  return _buffer.Buffer.from(_jsSha.sha256.arrayBuffer(payload));
}

function keccak(data) {
  return _buffer.Buffer.from(_jsSha2.keccak_256.buffer(data));
}

function toEthereumAddress(hexPublicKey) {
  return '0x' + keccak(_buffer.Buffer.from(hexPublicKey.slice(2), 'hex')).slice(-20).toString('hex');
}